<form #form="ngForm" *ngIf="showForm">
    <ui-dialog
        size="small"
        header="{{ 'payroll.run.showSendHoursApprovalReminderModalTitle' | translate }}"
        [form]="sendHoursApprovalReminderForm.form"
        [open]="showSendHoursApprovalReminderModal"
        [primaryButtonLabel]="'payroll.run.sendReminder'"
        [secondaryButtonLabel]="'cancel' | translate"
        [secondaryButtonType]="'ghost'"
        (primaryButtonPressed)="submitHoursApprovalReminderForm()"
        (secondaryButtonPressed)="showSendHoursApprovalReminderModal = false; sendHoursApprovalReminderForm.reset()"
        (closing)="showSendHoursApprovalReminderModal = false; sendHoursApprovalReminderForm.reset()"
    >
        <app-send-hours-approval-reminder-form #sendHoursApprovalReminderForm></app-send-hours-approval-reminder-form>
    </ui-dialog>

    <ui-confirmation-dialog
        #lockWithPendingHoursConfirmation
        header="payroll.run.pendingHoursWontBeAddedToThisPayroll"
        primaryButtonLabel="payroll.run.lockPayrollHours"
        secondaryButtonLabel="cancel"
    >
        <p>
            {{
                'payroll.run.thereAreHoursThatHaventBeenApprovedAndWontBeIncludedInThisPayrol'
                    | translate: { hours: totalPendingHours }
            }}
        </p>
        <p>{{ 'payroll.run.anyHoursApprovedAfterLockingWontBeAddedToThePayrollForThisPayPer' | translate }}</p>
        <p>{{ 'payroll.run.pleaseConsultYourJurisdictionToConfirmYourComplianceRequirements' | translate }}</p>
    </ui-confirmation-dialog>

    <ui-confirmation-dialog
        #lockWithNewHoursConfirmation
        header="payroll.run.newHoursAddedSinceLastRefresh"
        primaryButtonLabel="payroll.run.lockPayrollHours"
        secondaryButtonLabel="payroll.run.review"
    >
        {{ 'payroll.run.newPayrollHoursWereAddedAndOrApprovedSinceLastRefresh' | translate }}
    </ui-confirmation-dialog>

    <ui-confirmation-dialog
        #lockWithoutPendingHoursConfirmation
        header="payroll.run.lockPayrollHoursForThisPayPeriod"
        primaryButtonLabel="payroll.run.lockPayrollHours"
        secondaryButtonLabel="cancel"
    >
        <p>{{ 'payroll.run.anyHoursApprovedAfterLockingWontBeAddedToThePayrollForThisPayPer' | translate }}</p>
        <p>{{ 'payroll.run.pleaseConsultYourJurisdictionToConfirmYourComplianceRequirements' | translate }}</p>
    </ui-confirmation-dialog>

    <ui-dialog
        [open]="showUnlockWithNewHoursModal"
        size="small"
        #unlockWithNewHoursModal
        header="payroll.run.newHoursAddedWhileLocked"
        primaryButtonLabel="payroll.run.viewPayrollHours"
        (primaryButtonPressed)="showUnlockWithNewHoursModal = false; refreshHours()"
        (closing)="showUnlockWithNewHoursModal = false"
    >
        <p>{{ 'payroll.run.newpayrollhourswereaddedandOrApprovedWhileLocked' | translate }}</p>
    </ui-dialog>

    <app-table
        *ngIf="!tableLate.isEmpty"
        [table]="tableLate"
        [useStickyHeader]="false"
        [showOffset]="false"
        [title]="'payroll.run.lateHoursTitle' | translate"
        [subTitle]="'payroll.run.lateHoursContent' | translate"
        (selectionChanged)="selectionChanged($event)"
    >
        <div class="search-buttons">
            <ui-button (click)="onRefreshHours(true)" type="primary" [disabled]="hoursLocked" class="margin-right-2">
                <mat-icon svgIcon="refresh"></mat-icon>{{ 'payroll.run.refresh' | translate }}
            </ui-button>
        </div>
        <tfoot class="table-footer">
            <tr class="top-row">
                <td colspan="2">
                    <span class="margin-right-3">{{ 'payroll.run.totalEmployees' | translate }}</span>
                    {{ lateTotals.employees }}
                </td>
                <td></td>
                <td>{{ 'payroll.run.totalApprovedHours' | translate }}</td>
                <td>{{ lateTotals.approved.toFixed(2) }}</td>
                <td colspan="3"></td>
            </tr>
            <tr class="bottom-row">
                <td colspan="2"></td>
                <td></td>
                <td>{{ 'payroll.run.totalPendingHours' | translate }}</td>
                <td>{{ lateTotals.pending.toFixed(2) }}</td>
                <td colspan="3"></td>
            </tr>
        </tfoot>
        <div class="footer-buttons margin-top-3">
            <ui-button (click)="onAssignHours()" type="primary" [disabled]="hoursLocked || tableLate.isEmpty">{{
                'payroll.run.assignHoursButton' | translate
            }}</ui-button>
        </div>
    </app-table>

    <h2 class="margin-top-0">{{ 'payroll.run.payrollHours' | translate }}</h2>

    <p>{{ 'payroll.run.hoursCapturedInTimeOffAndTimeTrackingForThisPayrollPeriod' | translate }}</p>

    <ui-tip>
        <div
            [innerHTML]="'payroll.run.seeTheHumiGuideForMoreInfoOnTheTimeIntegrationAndStepByStepInstr' | translate"
        ></div>
    </ui-tip>

    <ui-banner *ngIf="hasPendingHours" variant="warning" class="margin-top-3">
        {{ 'payroll.run.payPeriodHasPendingHours' | translate }}
    </ui-banner>

    <div class="margin-y-3">
        <ui-button *ngIf="!hoursLocked" (click)="onLock()" type="primary" class="margin-right-2">
            <mat-icon svgIcon="lock"></mat-icon>{{ 'payroll.run.lockPayPeriod' | translate }}
        </ui-button>
        <ui-button *ngIf="hoursLocked" (click)="onUnlock()" type="outline" class="margin-right-2">
            <mat-icon svgIcon="unlock"></mat-icon>{{ 'payroll.run.unlockPayPeriod' | translate }}
        </ui-button>
        <ui-button
            (click)="showSendHoursApprovalReminderModal = true"
            type="outline"
            [disabled]="!lateTotals.pending && !totals.pending"
            class="margin-right-2"
        >
            <mat-icon svgIcon="mail"></mat-icon>{{ 'payroll.run.sendReminder' | translate }}
        </ui-button>
        <ui-button (click)="onRefreshHours()" type="primary" [disabled]="hoursLocked" class="margin-right-2">
            <mat-icon svgIcon="refresh"></mat-icon>{{ 'payroll.run.refresh' | translate }}
        </ui-button>
    </div>

    <app-table [table]="table" [useStickyHeader]="false">
        <tfoot class="table-footer">
            <tr class="top-row">
                <td colspan="2">
                    <span class="margin-right-3">{{ 'payroll.run.totalEmployees' | translate }}</span>
                    {{ totals.employees }}
                </td>
                <td>{{ 'payroll.run.totalApprovedHours' | translate }}</td>
                <td>{{ totals.approved.toFixed(2) }}</td>
                <td colspan="3"></td>
            </tr>
            <tr class="bottom-row">
                <td colspan="2"></td>
                <td>{{ 'payroll.run.totalPendingHours' | translate }}</td>
                <td>{{ totals.pending.toFixed(2) }}</td>
                <td colspan="3"></td>
            </tr>
        </tfoot>
    </app-table>
</form>
